export function disableWith() {
  // Sélectionner les éléments nécessaires
  const fixeInput = document.getElementById("workshop_part_with_price");
  const fixeHTLabel = document.querySelector(
    'label[for="workshop_part_with_tax_ht"]'
  );
  const fixeTTCLabel = document.querySelector(
    'label[for="workshop_part_with_tax_ttc"]'
  );
  const fixeHTInput = document.getElementById("workshop_part_with_tax_ht");
  const fixeTTCInput = document.getElementById("workshop_part_with_tax_ttc");
  const eurDiv = document.getElementById("workshop_part_with_eur");

  // Décocher et désactiver les inputs radio
  fixeHTInput.checked = false;
  fixeTTCInput.checked = false;
  fixeHTInput.disabled = true;
  fixeTTCInput.disabled = true;

  // Vider l'input de type numeric, le rendre readonly et supprimer le placeholder
  fixeInput.value = "";

  // Changer le curseur des labels en not-allowed
  fixeHTLabel.classList.remove("cursor-pointer");
  fixeHTLabel.classList.add("cursor-not-allowed");
  fixeHTLabel.classList.add("!bg-neutral-100");
  fixeTTCLabel.classList.remove("cursor-pointer");
  fixeTTCLabel.classList.add("cursor-not-allowed");
  fixeTTCLabel.classList.add("!bg-neutral-100");

  // Changer la couleur du texte HT ou TTC en gris clair
  fixeHTLabel.classList.add("text-gray-400");
  fixeTTCLabel.classList.add("text-gray-400");

  // Changer la couleur du texte "EUR" en gris clair
  eurDiv.classList.add("text-gray-400");
}

export function enableWith() {
  // Sélectionner les éléments nécessaires
  const fixeInput = document.getElementById("workshop_part_with_price");
  const fixeHTLabel = document.querySelector(
    'label[for="workshop_part_with_tax_ht"]'
  );
  const fixeTTCLabel = document.querySelector(
    'label[for="workshop_part_with_tax_ttc"]'
  );
  const eurDiv = document.getElementById("workshop_part_with_eur");
  const fixeHTInput = document.getElementById("workshop_part_with_tax_ht");
  const fixeTTCInput = document.getElementById("workshop_part_with_tax_ttc");

  // Réactiver les inputs radio
  fixeHTInput.disabled = false;
  fixeTTCInput.disabled = false;

  // Restaurer l'input de type numeric, enlever readonly et ajouter le placeholder
  fixeInput.removeAttribute("readonly");
  fixeInput.setAttribute("placeholder", "Ex: 10");
  fixeInput.classList.remove("!bg-neutral-100");

  // Changer le curseur des labels en pointer
  fixeHTLabel.classList.remove("cursor-not-allowed");
  fixeHTLabel.classList.remove("!bg-neutral-100");
  fixeHTLabel.classList.add("cursor-pointer");
  fixeTTCLabel.classList.remove("cursor-not-allowed");
  fixeTTCLabel.classList.remove("!bg-neutral-100");
  fixeTTCLabel.classList.add("cursor-pointer");

  // Restaurer la couleur du texte HT ou TTC
  fixeHTLabel.classList.remove("text-gray-400");
  fixeTTCLabel.classList.remove("text-gray-400");

  // Restaurer la couleur du texte "EUR"
  eurDiv.classList.remove("text-gray-400");

  // Vérifier si HT ou TTC est coché, sinon cocher HT par défaut
  if (!fixeHTInput.checked && !fixeTTCInput.checked) {
    fixeHTInput.checked = true;
  }
}
